// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"Overlay__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Overlay/Overlay.scss
 ** module id = 927
 ** module chunks = 1
 **/